import React from "react";

export const ProminLoader = (props: any) => {
  return <>{props.children}</>
}
export type withLoaderProps = {
  hideLoader: () => void;
  showLoader: () => void;
}
export default ProminLoader